export const AGENT_IDLE_STATE_DELAY_MS_MIN = 1000;
export const AGENT_IDLE_STATE_DELAY_MS_MAX = 60000;
export const CUSTOMER_IDLE_STATE_TIMEOUT_SEC_MIN = 1;
export const CUSTOMER_IDLE_STATE_TIMEOUT_SEC_MAX = 60;
export const CUSTOMER_IDLE_STATE_MAX_ATTEMPTS_MIN = 1;
export const CUSTOMER_IDLE_STATE_MAX_ATTEMPTS_MAX = 10;

export type ExpandedAgentIdleState = {
  enabled: boolean;
  delayMs: number;
  messages: string[];
  customerReplyTimeoutSec: number | null;
  customerSilenceThresholdSec: number | null;
  customerMaxAttempts: number | null;
};

export type ExpandedAgentIdleStateDraft = {
  enabled: boolean;
  delayMs: string;
  messages: string[];
  customerReplyTimeoutSec: string;
  customerSilenceThresholdSec: string;
  customerMaxAttempts: string;
};

export type IdleStateValidationErrors = Partial<
  Record<
    | 'delayMs'
    | 'messages'
    | 'customerReplyTimeoutSec'
    | 'customerSilenceThresholdSec'
    | 'customerMaxAttempts',
    string
  >
>;

export const createDefaultIdleStateDraft = (): ExpandedAgentIdleStateDraft => ({
  enabled: false,
  delayMs: '',
  messages: [],
  customerReplyTimeoutSec: '',
  customerSilenceThresholdSec: '',
  customerMaxAttempts: '',
});

export const mapIdleStateToDraft = (
  idleState?: Partial<ExpandedAgentIdleState> | null,
): ExpandedAgentIdleStateDraft => ({
  enabled: Boolean(idleState?.enabled),
  delayMs: idleState?.delayMs?.toString() ?? '',
  messages: Array.isArray(idleState?.messages) ? idleState.messages : [],
  customerReplyTimeoutSec: idleState?.customerReplyTimeoutSec?.toString() ?? '',
  customerSilenceThresholdSec: idleState?.customerSilenceThresholdSec?.toString() ?? '',
  customerMaxAttempts: idleState?.customerMaxAttempts?.toString() ?? '',
});
